'use strict';

const config = {
    "app": {
        "title": "DIAPERGATE",
        "reloadsec": 0,
        "if": "wlan0",
        "port": 9000,
        "timeoutDuration": 5000,
        "collectDuration": 10000,
        "maxCollectCount": 10,
        "TICKPERMIN": 9,
        "smallCount": 6,
        "midiumCount": 5,
        "massCount": 4,
        "SENSOR_VALUE": true,
        "RELEASE_MODE": true
    },
    "dbglevel": "info",
    "logdebug": "./logs/debug.log",
    "errlevel": "silly",
    "logerror": "./logs/error.log",
    "logkeep": 2,
    "workers": 2
};

var blelist = {};
function saveJSON(jsonFile, jsonData) {

}

var TICKPERMIN = config.app.TICKPERMIN; //

function calcMoving(list, min) {
    //console.log('list=', list);
    var len = list.length;
    var sum = 0;

    for (var i = 0; i < min - 1; i++) {
        sum = sum + list[i].CAP1.mean;	//m-1까지의 부분sum
    }

    for (var i = min - 1; i < list.length; i++) {
        sum = sum + list[i].CAP1.mean;
        list[i].moving = (sum / min);
        sum = sum - list[i - min + 1].CAP1.mean;
    }
    //console.log('result=', list);
}

function calcAbsDeviation(vals) {
    const sum = vals.reduce((t, c) => t + c, 0);
    const mean = sum / vals.length;
    const devtot = vals.reduce((t, c) => t + Math.abs(c - mean), 0);
    const stddev = devtot / vals.length;
    return { sum: sum, mean: parseInt(mean), devtot: parseInt(devtot.toFixed(0)), stddev: parseInt(stddev.toFixed(0)) };
}

async function insertSensorHistory(device, amount, value, REPLACEMENT, POSTURE, resultx, resulty, resultz) {
    const VCC_PER = (100 - ((30 - device.VCC) * 10));
    const jsonData = {
        "ID": device.SENSOR_ID,
        "AMOUNT": amount,
        "VALUE": value,
        "KIND": "0",
        "BATTERY": VCC_PER,
        "CONNECT": "0",
        "REPLACEMENT": REPLACEMENT,
        'POSTURE': POSTURE,
        'POSTURE_X': resultx.mean,
        'POSTURE_Y': resulty.mean,
        'POSTURE_Z': resultz.mean,
    };
    console.log('insertSensorHistory', new Date(device.detecttime), jsonData);

    if (((amount == 1 || amount == 2) && device.CHANGEDIAPER == 2)) {
		device.CHANGEDIAPER = 0;
	}
}

function measurement(sensorID) {

    this.init = () => {
        return {
            SENSOR_ID: sensorID,
            CHANGEDIAPER: 1,
            tryConnect: 0,
            collectCount: 0,
            collectTime: null,
            detect: false,
            open: {
                "CAP1": {
                    "sum": 223915,
                    "mean": 31987,
                    "devtot": 111,
                    "stddev": 16
                },
                "CAP2": {
                    "sum": 279113,
                    "mean": 39873,
                    "devtot": 79,
                    "stddev": 11
                },
                "ACC_X": {
                    "sum": -678,
                    "mean": -96,
                    "devtot": 91,
                    "stddev": 13
                },
                "ACC_Y": {
                    "sum": -106,
                    "mean": -15,
                    "devtot": 428,
                    "stddev": 61
                },
                "ACC_Z": {
                    "sum": -28254,
                    "mean": -4036,
                    "devtot": 142,
                    "stddev": 20
                },
                "time": 1660201025636,
                "count": 0
            },
            base: {},
            move: [],
            small: [],
            midium: [],
            mass: [],
            data: {}
        };
    }

    this.calcMeasurement = (device) => {
        const data = Object.values(device.data);
        const lastTime = data[data.length - 1].TIME;
        const nowTime = (new Date(lastTime)).getTime();
        device.detecttime = nowTime;

        console.log('data:', data, nowTime);
        const result1 = calcAbsDeviation(data.map(el => parseInt(el.CAP1)));
        console.log('cap1 =', result1);

        const result2 = calcAbsDeviation(data.map(el => parseInt(el.CAP2)));
        console.log('cap2 =', result2);

        const resultx = calcAbsDeviation(data.map(el => parseInt(el.ACC_X)));
        console.log('x =', resultx);

        const resulty = calcAbsDeviation(data.map(el => parseInt(el.ACC_Y)));
        console.log('y =', resulty);

        const resultz = calcAbsDeviation(data.map(el => parseInt(el.ACC_Z)));
        console.log('z =', resultz);

        device.data = {};
        const diffz = Math.abs(resultz.mean - (-4153)); // flip over -4150  
        console.log('diffz=', diffz);
        const flipover = diffz < 1000 ? true : false;

        const diffz2 = Math.abs(resultz.mean - (4150)); // lay down ( +4150 ) 
        console.log('diffz2=', diffz2);
        const laydown = diffz2 < 1000 ? true : false;

        const diffz3 = Math.abs(resultz.mean - (-1000)); // stand up :  +1000  ~ -1000
        console.log('diffz3=', diffz3);
        const standup1 = diffz3 < 1000 ? true : false;

        const diffz4 = Math.abs(resultz.mean - (1000)); // stand up :  +1000  ~ -1000
        console.log('diffz4=', diffz4);
        const standup2 = diffz4 < 1000 ? true : false;

        const diffy = Math.abs(resulty.mean - (-4059)); // lay right  
        console.log('diffy=', diffy);
        const layright = diffy < 2000 ? true : false;

        const diffy2 = Math.abs(resulty.mean - (4059)); // lay left  
        console.log('diffy2=', diffy2);
        const layleft = diffy2 < 2000 ? true : false;

        const standup = standup1 || standup2 ? true : false;
        var REPLACEMENT = '0';
        var POSTURE = flipover ? 'flipover' : '';
        POSTURE = laydown ? POSTURE + '^laydown' : POSTURE;
        POSTURE = standup1 ? POSTURE + '^standup1' : POSTURE;
        POSTURE = standup2 ? POSTURE + '^standup2' : POSTURE;
        POSTURE = layleft ? POSTURE + '^layleft' : POSTURE;
        POSTURE = layright ? POSTURE + '^layright' : POSTURE;

        console.log('detect...', POSTURE);

        if (flipover && diffz < 200 && resultz.stddev < 100 && device.open.time == null && result1.stddev < 20)  // desktop flipover
        {
            console.log("Update open values");
            device.open.CAP1 = result1;
            device.open.CAP2 = result2;
            device.open.ACC_X = resultx;
            device.open.ACC_Y = resulty;
            device.open.ACC_Z = resultz;
            device.open.time = nowTime;
            device.open.count = 0;
            saveJSON('./blelist.json', blelist);
            insertSensorHistory(device, 0, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
        }

        if (device.open.time != null) {
            // check open
            const diff2cap1 = Math.abs(parseInt(result1.mean) - parseInt(device.open.CAP1.mean));
            console.log('diff2cap1=', diff2cap1);
            if (device.CHANGEDIAPER == 1 || (diff2cap1 < 200 && flipover && diffz < 200 && resultz.stddev < 40 && result1.stddev < 50
                && ((device.mass.length + device.midium.length + device.small.length) > config.app.smallCount))) {
                console.log('open detect!!!', diff2cap1);
                device.base = {};
                device.small = [];
                device.midium = [];
                device.mass = [];
                device.move = [];
                saveJSON('./blelist.json', blelist);
                REPLACEMENT = '1';
                device.open.count++;
                // if ((device.open.count % 3) == 0)  // 2min
                {
                    insertSensorHistory(device, 0, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                }
                device.CHANGEDIAPER = device.CHANGEDIAPER == 1 ? 2 : device.CHANGEDIAPER;

            } else {

                if (device.CHANGEDIAPER == 2 || (diff2cap1 > 2000 && diff2cap1 < 6000 && result1.stddev < 30)) {
                    if (device.CHANGEDIAPER == 2 || device.base.time == null || (device.base != null && nowTime < (device.base.time + 60000))) {
                        console.log('close detect!!!', diff2cap1);
                        if (device.base.time == null && result1.stddev < 20) {
                            console.log('close confirm!!!', diff2cap1);
                            device.base.CAP1 = result1,
                                device.base.CAP2 = result2,
                                device.base.ACC_X = resultx,
                                device.base.ACC_Y = resulty,
                                device.base.ACC_Z = resultz,
                                device.base.time = nowTime;
                            device.move = [];
                            saveJSON('./blelist.json', blelist);
                            insertSensorHistory(device, 1, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                        } else if (device.base.time != null && result1.stddev < device.base.CAP1.stddev) {
                            console.log('close update!!!', diff2cap1);
                            device.base.CAP1 = result1,
                                device.base.CAP2 = result2,
                                device.base.ACC_X = resultx,
                                device.base.ACC_Y = resulty,
                                device.base.ACC_Z = resultz,
                                device.move = [];
                            saveJSON('./blelist.json', blelist);
                        }
                        REPLACEMENT = '0';
                    }
                }
                if (device.base.time != null && nowTime > (device.base.time + 60000)) {
                    // check detect
                    var diffcap1 = parseInt(result1.mean) - parseInt(device.base.CAP1.mean);
                    console.log('check diffcap1=', diffcap1);
                    const detect = {
                        CAP1: result1,
                        CAP2: result2,
                        ACC_X: resultx,
                        ACC_Y: resulty,
                        ACC_Z: resultz,
                        diffCap: diffcap1,
                        REPLACEMENT: REPLACEMENT,
                        time: nowTime
                    }
                    device.move.push({ ...detect });
                    while (device.move.length > (20 * 5 * TICKPERMIN)) // 20 = 60분  ,  5시간
                        device.move.shift();
                    console.log('device.move=', device.move.map(el => parseInt(el.CAP1.mean)));
                    if (device.move.length < TICKPERMIN) {
                        console.log('move.length=', device.move.length);
                        if (device.move.length == 1) {
                            insertSensorHistory(device, 2, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                        }
                    } else {
                        if (device.move.length == TICKPERMIN) {
                            insertSensorHistory(device, 3, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                        }
                        const lastTime = device.move[device.move.length - 1].time;
                        {
                            if (device.move.length > (TICKPERMIN)) {
                                calcMoving(device.move, (TICKPERMIN)); // n times 이동 평균
                                var listavg = device.move.map(el => parseInt(el.CAP1.mean));
                                var totavgcap1 = calcAbsDeviation(listavg);

                                var mvdata = device.move.map(el => parseInt(el.moving));
                                mvdata = mvdata.filter(el => el);

                                //mvdata = mvdata.slice(0, ((mvdata.length / 3) * 2));
                                console.log('mvdata=', mvdata);
                                const movingtotal = calcAbsDeviation(mvdata);
                                const movingprev = calcAbsDeviation(mvdata.slice((mvdata.length / 2) * 1, mvdata.length));
                                const movingnext = calcAbsDeviation(mvdata.slice((mvdata.length / 3) * 2, mvdata.length));
                                let lastbeg = (mvdata.length / 3) * 2;
                                lastbeg = lastbeg < (mvdata.length - 6) ? (mvdata.length - 6) : lastbeg;
                                const movinglast = calcAbsDeviation(mvdata.slice(lastbeg, mvdata.length));
                                const lastcap1 = parseInt(device.move[device.move.length - 1].CAP1.mean);
                                const movingcap1 = parseInt(movingnext.mean) - parseInt(movingprev.mean);
                                var selectmoving = movingtotal.mean < movingprev.mean ? movingtotal.mean : movingprev.mean;
                                selectmoving = movingnext.mean < selectmoving ? movingnext.mean : selectmoving;
                                const moving2cap1 = parseInt(movinglast.mean) - parseInt(selectmoving);
                                console.log('movingcap1=', movingcap1, moving2cap1, movingtotal, movingprev, movingnext, movinglast);
                                diffcap1 = movingcap1 > moving2cap1 ? movingcap1 : moving2cap1;

                                const dcount = device.mass.length + device.midium.length + device.small.length;
                                console.log('insert diffcap1=', diffcap1, (new Date(lastTime)).toLocaleTimeString('ko-KR') , dcount ); // 90ml

                                if (diffcap1 > 60 && diffcap1 < 90) {
                                    console.log('small detect!!!', diffcap1, device.small.length); // 90ml
                                    device.small.push(detect);

                                    while (device.small.length > 300) {
                                        device.small.shift();
                                    }
                                    if ((device.small.length % config.app.smallCount) == (config.app.smallCount - 1))	// 3min
                                    {
                                        insertSensorHistory(device, 60, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                                    }
                                } else if (diffcap1 >= 90 && diffcap1 < 150) {
                                    console.log('midium detect!!!', diffcap1, device.midium.length); // 100ml
                                    device.midium.push(detect);
                                    while (device.midium.length > 300) {
                                        device.midium.shift();
                                    }
                                    if (((device.midium.length + device.small.length) % (config.app.midiumCount)) == (config.app.midiumCount - 1))	// 3min
                                    {
                                        device.counter = device.counter == undefined ? 0 : (++device.counter);
                                        if ((device.counter % 3) == 0) {
                                            insertSensorHistory(device, 90, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                                        } else {
                                            insertSensorHistory(device, 80, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                                        }
                                    }
                                } else if (diffcap1 >= 150 && diffcap1 < 700) {
                                    console.log('mass detect!!!', diffcap1, device.mass.length); // 200ml
                                    device.mass.push(detect);
                                    while (device.mass.length > 300) {
                                        device.mass.shift();
                                    }
                                    if (((device.mass.length + device.midium.length + device.small.length) % config.app.massCount) == (config.app.massCount - 1))	// 3min
                                    {
                                        device.counter = device.counter == undefined ? 0 : (++device.counter);
                                        if ((device.counter % 3) == 0) {
                                            insertSensorHistory(device, 95, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                                        } else {
                                            insertSensorHistory(device, 85, result1.mean, REPLACEMENT, POSTURE, resultx, resulty, resultz);
                                        }
                                    }
                                }
                                saveJSON('./blelist.json', blelist);
                            }
                        }

                    }
                }
            }
        }
    }
}

export default measurement;